var cursor = document.querySelector('.cursor');

function isiOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

function isMobile() {
  return isAndroid() || isiOS();
}

//if not mobile,  add custom mouse
if (!isMobile()) {
  var a = document.querySelectorAll(
    'a,.cursor-pointer,.cursorCircleDark,.cursorCircleLight,.basicHover'
  );
  var nav = document.getElementById('mainNav');
  var mobileNav = document.getElementById('mobileMenu');
  var footer = document.getElementById('footer');

  document.addEventListener('mousemove', function (e) {
    cursor.style.left = e.clientX - cursor.offsetWidth / 2 + 'px';
    cursor.style.top = e.clientY - cursor.offsetHeight / 2 + 'px';
  });

  document.addEventListener('mousedown', function () {
    cursor.classList.add('click');
  });

  document.addEventListener('mouseup', function () {
    cursor.classList.remove('click');
  });

  a.forEach((item) => {
    item.addEventListener('mouseover', () => {
      if (mobileNav.contains(item)) {
        //if mobile nav
        cursor.classList.add('hoverLight');
        cursor.classList.add('zIndexMobileNav');
      } else if (nav.contains(item)) {
        //if nav
        if (item.classList.contains('cursorCircleDark')) {
          //if dark nav - dark color hover
          cursor.classList.add('hoverDark');
        } else {
          //light color hover
          cursor.classList.add('hoverLight');
        }
        if (window.innerWidth > 1280) {
          cursor.classList.add('zIndexNav');
        }
      } else if (footer.contains(item)) {
        //if footer
        cursor.classList.add('hoverLight');
        cursor.classList.add('zIndexFooter');
      } else if (item.classList.contains('basicHover')) {
        // basic hover
        cursor.classList.add('hoverLight');
      } else if (item.classList.contains('cursorCircleDark')) {
        //dark circle hover
        cursor.classList.add('hoverDark');
        cursor.classList.add('zIndexBasic');
      } else {
        //light circle hover
        cursor.classList.add('hoverLight');
        cursor.classList.add('zIndexBasic');
      }
    });

    item.addEventListener('mouseleave', () => {
      cursor.classList.remove('hoverDark');
      cursor.classList.remove('hoverLight');
      cursor.classList.remove('zIndexBasic');
      cursor.classList.remove('zIndexNav');
      cursor.classList.remove('zIndexFooter');
    });
  });
} else {
  cursor.style.display = 'none';
}
